import { GoogleLogin } from "@react-oauth/google";
import React from 'react';


const LoginButton = () => {
  const handleSuccess = (credentialResponse) => {
    const token = credentialResponse.credential;
    localStorage.setItem("Token", token);
    window.location.reload();
  };

  return (
    <GoogleLogin
      onSuccess={handleSuccess}
      onError={() => console.error("Login Failed")}
    />
  );
};

export default LoginButton;
